<template>
    <a-modal :open="open" :footer="null" title="Создание резидента" width="720px" class="rm"
        @cancel="onCancel">
        <p class="rm_subtitle">
            Контрагента с ИИН {{ iin }} нет в КИАС. Заведите карточку — после сохранения
            данные подставятся в заявление.
        </p>

        <!-- Та же форма, что и на /create-contragent: один набор полей и один
             POST /V1/road-accidents/set-subject на оба сценария. -->
        <div class="rm_form">
            <contragent-form :key="iin" :iin="iin" embedded @created="onCreated" />
        </div>
    </a-modal>
</template>

<script setup>
import { Modal } from 'ant-design-vue';
import ContragentForm from '@/views/create-contragent/components/contragent-form/contragent-form.vue';

const AModal = Modal;

defineProps({
    open: { type: Boolean, default: false },
    // ИИН, по которому карточка не нашлась: правим его в форме заявления, не здесь.
    iin: { type: String, default: '' },
});

const emit = defineEmits(['close', 'created']);

const onCreated = (createdIin) => emit('created', createdIin);
const onCancel = () => emit('close');
</script>

<style lang="scss" scoped>
.rm_subtitle {
    font-family: Roboto, sans-serif;
    font-size: 13px;
    line-height: 20px;
    color: #909090;
    margin: 0;
}

// Форма верстается под страницу — в модалке ужимаем отступ и кнопку.
.rm_form {
    :deep(.contragent-form) {
        margin-top: 20px;
    }

    :deep(.submit-button) {
        width: 100%;
    }
}
</style>
